import React, { Component } from 'react';
// import EditableCaption from '../../../../../../components/EditableCaption';
import { Icon } from '@lyearn-team/frontend-components';

class FlashCardGrid extends Component {
  state = {
    flipClass: 'block-flashcard--flipped',
    backFlippedCards: [],
    showHint: true,
    lessonId: this.props.lesson.id
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lesson.id !== prevState.lessonId) {
      return {
        backFlippedCards: [],
        lessonId: nextProps.lesson.id
      };
    }
    return null;
  }

  // componentDidUpdate(prevProps) {
  //   if (prevProps.lesson.id !== this.props.lesson.id) {
  //     this.setState({
  //       backFlippedCards: []
  //     });
  //   }
  // }

  showFront = index => () => {
    // alert(index);
    const temparry = this.state.backFlippedCards;
    temparry.push(index);
    this.setState({
      backFlippedCards: temparry,
      showHint: false
    });
  };

  showBack = index => () => {
    const temparry1 = this.state.backFlippedCards;

    const tempIndex = temparry1.indexOf(index);
    if (tempIndex > -1) {
      temparry1.splice(tempIndex, 1);
    }

    //  temparry1.splice(temparry1.indexOf(index) > -1, 1);
    this.setState({
      backFlippedCards: temparry1
    });

    // switch (cardType) {
    //   case 'CARD1': {
    //     this.setState({ flipClass: '' });
    //     break;
    //   }
    //   case 'CARD2': {
    //     this.setState({ flipClassCard2: '' });
    //     break;
    //   }
    //   case 'CARD3': {
    //     this.setState({ flipClassCard3: '' });
    //     break;
    //   }
    //   default:
    //     break;
    // }
    // this.setState({ flipClass: '' });
  };

  frontCard = (item, index) => {
    switch (item.front.type) {
      case 'description': {
        this.frontCardDescriptionSection(item, index);
        break;
      }
      case 'fullimage': {
        this.frontCardDescriptionSection(item, index);
        break;
      }
      case 'image': {
        this.frontCardDescriptionSection(item, index);
        break;
      }
      default:
        break;
    }
  };

  backCard = (item, index) => {
    switch (item.back.type) {
      case 'description': {
        this.backCardDescriptionSection(item, index);
        break;
      }
      case 'fullimage': {
        this.backCardFullimageSection(item, index);
        break;
      }
      case 'image': {
        this.backCardCenterimageSection(item, index);
        break;
      }
      default:
        break;
    }
  };

  frontCardDescriptionSection = (item, index) => (
    <div
      aria-hidden="false"
      className="block-flashcard__front block-flashcard__front--description"
      role="button"
      tabIndex="-1"
      onClick={this.showFront(index)}
    >
      <div className="block-flashcard__content brand-border-acent">
        {/* <div className={'block-flashcard__center brand--linkColor ' + (item.front.description.length > 80 ? 'block-flashcard__center--long1' : '')} aria-label="Flashcard front - Front of card 1"> */}
        <div
          className="block-flashcard__center brand--linkColor block-flashcard__center--longnew"
          aria-label="Flashcard front - Front of card 1"
        >
          <div
            aria-hidden="false"
            className="block-flashcard__description brand--head brand--linkColor"
          >
            <div className="fr-view">{item.front.description}</div>
          </div>
        </div>
      </div>
      <div
        className="block-flashcard__flip brand--ui block-flashcard__flip--detailed"
        role="button"
        tabIndex="-1"
        onClick={this.showFront(index)}
      >
        <span className="flip-text">
          {this.props.lesson.settings.showHint && this.state.showHint && index === 0
            ? 'Click to flip '
            : ''}
        </span>
        <span className="flip-icon">
          <Icon type="flip" style={{ fill: '#707885' }} />
        </span>
      </div>
    </div>
  );

  frontCardFullimageSection = (item, index) => (
    <div
      aria-hidden="false"
      className="block-flashcard__front block-flashcard__front--fullimage"
      role="button"
      tabIndex="-1"
      onClick={this.showFront(index)}
    >
      <div
        className="block-flashcard__content"
        style={{ backgroundImage: 'url(' + item.front.media.image.src + ')' }}
      >
        <div className="block-flashcard__center brand--linkColor" aria-label="Flashcard front" />
      </div>
      <div
        className="block-flashcard__flip brand--ui"
        role="button"
        tabIndex="-1"
        onClick={this.showFront(index)}
      >
        <span className="flip-text" />
        <span className="flip-icon">
          <Icon type="flip" style={{ fill: '#707885' }} />
        </span>
      </div>
    </div>
  );

  frontCardCenterimageSection = (item, index) => (
    <div
      aria-hidden="true"
      className="block-flashcard__front block-flashcard__front--image"
      role="button"
      tabIndex="-1"
      onClick={this.showFront(index)}
    >
      <div className="block-flashcard__content">
        <div
          className="block-flashcard__center brand--linkColor block-flashcard__center--column"
          aria-label="Flashcard back"
        >
          <div
            className="block-flashcard__image"
            style={{ backgroundImage: 'url(' + item.front.media.image.src + ')' }}
          >
            {/* <img src="https://images.articulate.com/f:jpg|png,a:retain,b:fff/assets/rise/assets/block-defaults/mountains.jpg"> */}
          </div>
        </div>
      </div>
      <div
        className="block-flashcard__flip brand--ui"
        role="button"
        tabIndex="-1"
        onClick={this.showFront(index)}
      >
        <span className="flip-text" />
        <span className="flip-icon">
          <Icon type="flip" style={{ fill: '#707885' }} />
        </span>
      </div>
    </div>
  );

  backCardDescriptionSection = (item, index) => (
    <div
      aria-hidden="true"
      className="block-flashcard__back block-flashcard__back--description"
      role="button"
      tabIndex="-1"
      onClick={this.showBack(index)}
    >
      <div className="block-flashcard__content">
        {/* <div className={'block-flashcard__center brand--linkColor ' + (item.back.description.length > 80 ? 'block-flashcard__center--long block-flashcard__center--long--front block-flashcard__center--overflow' : '')} aria-label="Flashcard back - Back of card 1"> */}
        <div
          className="block-flashcard__center brand--linkColor block-flashcard__center--longnew"
          aria-label="Flashcard back - Back of card 1"
        >
          <div
            aria-hidden="true"
            className="block-flashcard__description brand--head brand--linkColor"
          >
            <div className="fr-view">{item.back.description}</div>
          </div>
        </div>
      </div>
      <div
        className="block-flashcard__flip brand--ui block-flashcard__flip--detailed"
        role="button"
        tabIndex="-1"
        onClick={this.showBack(index)}
      >
        <span className="flip-text" />
        <span className="flip-icon">
          <Icon type="flip" style={{ fill: '#707885' }} />
        </span>
      </div>
    </div>
  );

  backCardFullimageSection = (item, index) => (
    <div
      aria-hidden="true"
      className="block-flashcard__back block-flashcard__back--fullimage"
      role="button"
      tabIndex="-1"
      onClick={this.showBack(index)}
    >
      <div
        className="block-flashcard__content"
        style={{ backgroundImage: 'url(' + item.back.media.image.src + ')' }}
      >
        <div className="block-flashcard__center brand--linkColor" aria-label="Flashcard back" />
      </div>
      <div
        className="block-flashcard__flip brand--ui block-flashcard__flip--detailed"
        role="button"
        tabIndex="-1"
        onClick={this.showBack(index)}
      >
        <span className="flip-text" />
        <span className="flip-icon">
          <Icon type="flip" style={{ fill: '#707885' }} />
        </span>
      </div>
    </div>
  );

  backCardCenterimageSection = (item, index) => (
    <div
      aria-hidden="true"
      className="block-flashcard__back block-flashcard__back--image"
      role="button"
      tabIndex="-1"
      onClick={this.showBack(index)}
    >
      <div className="block-flashcard__content">
        <div
          className="block-flashcard__center brand--linkColor block-flashcard__center--column"
          aria-label="Flashcard back"
        >
          <div
            className="block-flashcard__image"
            style={{ backgroundImage: 'url(' + item.back.media.image.src + ')' }}
          >
            {/* <img src="https://images.articulate.com/f:jpg|png,a:retain,b:fff/assets/rise/assets/block-defaults/mountains.jpg"> */}
          </div>
        </div>
      </div>
      <div
        className="block-flashcard__flip brand--ui"
        role="button"
        tabIndex="-1"
        onClick={this.showBack(index)}
      >
        <span className="flip-text" />
        <span className="flip-icon">
          <Icon type="flip" style={{ fill: '#707885' }} />
        </span>
      </div>
    </div>
  );

  render() {
    const { flipClass } = this.state;

    const items = this.props.lesson.items;

    // console.log(this.props.lesson.settings.showHint);
    // console.log(this.state.backFlippedCards);

    return (
      <div className="block__content">
        <div
          aria-label="Flashcard grid"
          className="block-flashcards blocks-flashcard--column"
          style={{ paddingTop: '30px', paddingBottom: '30px' }}
        >
          <div className="block-flashcards__wrapper">
            <div>
              {items.map((item, index) => (
                <section
                  className={
                    'block-flashcard block-flashcard--small '
                    + (this.state.backFlippedCards.indexOf(index) > -1 ? flipClass : '')
                  }
                  key={index}
                >
                  <div className="block-flashcard__wrapper">
                    {item.back.type === 'description'
                      ? this.backCardDescriptionSection(item, index)
                      : ''}
                    {item.back.type === 'fullimage'
                      ? this.backCardFullimageSection(item, index)
                      : ''}
                    {item.back.type === 'image' ? this.backCardCenterimageSection(item, index) : ''}
                    {item.front.type === 'description'
                      ? this.frontCardDescriptionSection(item, index)
                      : ''}
                    {item.front.type === 'fullimage'
                      ? this.frontCardFullimageSection(item, index)
                      : ''}
                    {item.front.type === 'image'
                      ? this.frontCardCenterimageSection(item, index)
                      : ''}
                  </div>
                </section>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FlashCardGrid;
